import type { SidebarItem } from './SidebarTypes';

// Ítems que van fijos al fondo del menú lateral, fuera de la lista.
const PINNED_KEYS = ['settings'];

/** Separa los ítems fijos (ya filtrados por permisos) del resto del menú. */
export const splitPinnedItems = (sections: SidebarItem[]) => {
  const pinned: SidebarItem[] = [];
  const main = sections.map((section) =>
    section.items
      ? {
          ...section,
          items: section.items.filter((item) => {
            if (!PINNED_KEYS.includes(item.key)) return true;
            pinned.push(item);
            return false;
          }),
        }
      : section
  );
  return {
    main,
    pinned: pinned.length ? [{ key: 'pinned', title: '', items: pinned }] : [],
  };
};
